import { _t } from "@/tools/Utils";

const { required } = require("vuelidate/lib/validators");
import jalali_moment from "moment-jalaali";
export const CERT_FORM_SCHEMA = {
  /* Form SCHEMA */
  schema: [
    {
      id: "fullName",
      label: "fullName",
      placeholder: null,
      cols: 12,
      lg: 4,
      md: 6,
      sm: 12,
      type: "text",
    },
    {
      id: "nationalCode",
      label: "nationalCode",
      placeholder: null,
      cols: 12,
      lg: 4,
      md: 6,
      sm: 12,
      type: "text",
    },
    {
      id: "level",
      label: "level",
      placeholder: null,
      cols: 12,
      lg: 4,
      md: 6,
      sm: 12,
      type: "select",
      value: "value",
      items: [
        { text: _t("attribute.Diplom"), value: "Diplom" },
        { text: _t("attribute.FogDiplom"), value: "FogDiplom" },
        { text: _t("attribute.Lisans"), value: "Lisans" },
        { text: _t("attribute.FogLisans"), value: "FogLisans" },
        { text: _t("attribute.Doctora"), value: "Doctora" },
      ],
    },
    {
      id: "levelType",
      label: "levelType",
      placeholder: "levelType_ex",
      cols: 12,
      lg: 4,
      md: 6,
      sm: 12,
      type: "text",
    },
    {
      id: "birthday",
      label: "birthday",
      placeholder: null,
      cols: 12,
      lg: 4,
      md: 6,
      sm: 12,
      type: "date",
    },
    {
      id: "lastMajor",
      label: "lastMajor",
      placeholder: "lastMajor_ex",
      cols: 12,
      lg: 4,
      md: 6,
      sm: 12,
      type: "text",
    },
    {
      id: "postalCode",
      label: "postalCode",
      placeholder: null,
      cols: 12,
      lg: 4,
      md: 6,
      sm: 12,
      type: "text",
    },
    {
      id: "howToSend",
      label: "howToSend",
      placeholder: null,
      cols: 12,
      lg: 4,
      md: 6,
      sm: 12,
      type: "select",
      value: "value",
      items: [
        { text: _t("attribute.Post"), value: "Post" },
        { text: _t("attribute.Terminal"), value: "Terminal" },
        { text: _t("attribute.Tpax"), value: "Tpax" },
      ],
    },
    {
      id: "nationalCartPhoto",
      label: "nationalCartPhoto",
      placeholder: null,
      cols: 12,
      lg: 4,
      md: 6,
      sm: 12,
      type: "file",
    },
    {
      id: "address",
      label: "address",
      placeholder: null,
      cols: 12,
      lg: 4,
      md: 6,
      sm: 12,
      type: "textarea",
    },

    {
      id: "startTime",
      label: "startTime",
      placeholder: null,
      cols: 12,
      lg: 4,
      md: 6,
      sm: 12,
      type: "date",
    },
    {
      id: "personalPhoto",
      label: "personalPhoto",
      placeholder: null,
      cols: 12,
      lg: 4,
      md: 6,
      sm: 12,
      type: "file",
    },
  ],

  /* Form MODEL */
  model: {
    fullName: null,
    nationalCode: null,
    level: null,
    levelType: null,
    birthday: null,
    lastMajor: null,
    address: null,
    postalCode: null,
    personalPhoto: null,
    nationalCartPhoto: null,
    howToSend: null,
    startTime: jalali_moment(new Date()).locale("fa").format("jYYYY/jMM/jDD"),
  },

  /* VALIDATION SCHEMA */
  validations: {
    form: {
      fullName: {
        required,
      },
      nationalCode: {
        required,
      },
      level: {
        required,
      },
      levelType: {
        required,
      },
      birthday: {
        required,
      },
      lastMajor: {
        required,
      },
      address: {
        required,
      },
      postalCode: {
        required,
      },
      personalPhoto: {
        required,
      },
      nationalCartPhoto: {
        required,
      },
      howToSend: {
        required,
      },
      startTime: {
        required,
      },
    },
  },
};
